
import React from 'react';
import classNames from 'classnames';
import styles from './AutoSave.css';

import autoSaveClose from './autoSaveClose.png';
import autoSaveOn from './autoSaveOn.png';

const AutoSave = (props) => {

    return (
        <>
            <input type="checkbox" id="autoSave" className={classNames(styles.checkboxs)} onChange={props.handleAutoSave} checked={props.autoSave} />
            <label htmlFor="autoSave" className={classNames(styles.checkboxLabel)}>
                <span>
                    <img src={props.autoSave ? autoSaveOn : autoSaveClose} style={{ height: '1rem', verticalAlign: 'middle' }} />
                </span>
                <span>
                    自动保存
                </span>

            </label>
        </>
    )
}

export default AutoSave;
